import React, { Component } from 'react';
import { Segment, Form, Loader, Dimmer } from 'semantic-ui-react';
import i18next from 'i18next';
import {
  clone,
  map,
  pipe,
  filter,
  complement,
  isEmpty,
  prepend,
  find,
  sortBy,
  prop
} from 'ramda';
import { updateInPath, adminQuery, logError } from '../../../../common/utils';
import gql from 'graphql-tag';
//import { CSVLink } from "react-csv";


class TableHeader extends Component {
  constructor(props) {
    super();

    this.state = {
      filters: {},
      competitions: [],
      users: {
        loading: false,
        data: []
      },
      csv: {
        generating: false,
        code: null,
        data: null
      }
    };

    this.debouncer = null;
  }

  handleChange = (e, { name, value }) => {
    this.setState(s => updateInPath(s, 'filters.' + name, value));
  }

  handleEventChange = (e, event) => {
    const item = find(({value}) => value === event.value, event.options);

    const competitions = pipe(
      clone(),
      map(c => {
        let itemText = c.code + ' - ';
        itemText += JSON.parse(c.i18n_title)[i18next.language];
        itemText += ' (' + c.date + ' ' + c.beginTime + ') ';
        itemText += c.participantCount + '/' + c.participantLimit;
        
        return {
          key: c.id,
          value: c.id,
          code: c.code,
          text: itemText
        };
      }),
      sortBy(prop('text')),
      // add empty value so that competition could be unselected
      prepend({key: 0, text: '', value: ''})
    )(item.competitions);
    
    this.setState(s => updateInPath(s, 'competitions', competitions));
  }

  handleCompetitionChange = (e, competition) => {
    const item = find(({value}) => value === competition.value, competition.options);
    this.setState(s => updateInPath(s, 'filters.competitionId', item.value));
    this.setState(s => updateInPath(s, 'csv.data', null));
    this.setState(s => updateInPath(s, 'csv.code', item.code));
  };

  getFiltersObjForDynamoDb = () =>
    pipe(
      clone(),
      filter(complement(isEmpty())),
      map(value => {
        return { contains: value };
      })
    )(this.state.filters);

  // TODO this should be a generic functionality
  getUser = (a, { searchQuery }) => {
    if (this.debouncer) {
      window.clearTimeout(this.debouncer);
    }
    
    if (searchQuery) {
      let q = gql`query GetUserId($email: String!) { getUserId(email: $email) { text value } }`;
      
      this.debouncer = window.setTimeout(() => {
        this.setState(s => updateInPath(s, 'users.loading', true));
        adminQuery(q, { email: searchQuery })
          .then(({ getUserId: users }) => {
            let withBlank = prepend({text: '', value: ''}, users);
            this.setState(s => updateInPath(s, 'users.data', withBlank));
            this.setState(s => updateInPath(s, 'users.loading', false));
          })
          .catch(logError);
      }, 300);
    } else {
      this.setState(s => updateInPath(s, 'users.data', []));
    }
  }

  handleSubmit = () => {
    this.props.onSubmit(this.getFiltersObjForDynamoDb());
  }

  handleDownload = () => {
    this.setState(s => updateInPath(s, 'csv.generating', true));
    this.props.onDownload(this.state.filters.competitionId, (csv) => {
      this.setState(s => updateInPath(s, 'csv.data', csv));
      this.setState(s => updateInPath(s, 'csv.generating', false));
    });
  }

  render() {
    const {
      events,
      disabled
    } = this.props;

    const csv = this.state.csv,
          e = pipe(
            filter(e => e.type === 'WORKSHOP'),
            sortBy(prop('text'))
          )(events || []);

    return (
      <div>
        <Segment basic>
          <Form>
            <Form.Group>
              <Form.Dropdown
                width={4}
                placeholder='Event'
                selection
                options={e}
                onChange={this.handleEventChange}
              />
              <Form.Dropdown
                width={12}
                disabled={!this.state.competitions.length}
                placeholder='Workshop'
                selection
                search
                options={this.state.competitions}
                name='competitionId'
                onChange={this.handleCompetitionChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Dropdown
                width={4}
                placeholder='User email'
                name='userId'
                minCharacters={3}
                search
                selection
                onSearchChange={this.getUser}
                onChange={this.handleChange}
                loading={this.state.users.loading}
                options={this.state.users.data} />
              <Form.Button
                size='tiny'
                disabled={disabled || isEmpty(this.getFiltersObjForDynamoDb())}
                content='Search'
                onClick={this.handleSubmit}
              />
              {/* { !!csv.data && <CSVLink */}
              {/*                   data={this.state.csv.data} */}
              {/*                   filename={csv.code} */}
              {/*                   className='ui icon button tiny' */}
              {/*                   target='_blank'> */}
              {/*                   Download CSV ({csv.code}) */}
              {/*                 </CSVLink> } */}
              {/* { !csv.data && !csv.generating && <Button */}
              {/*                                     size='tiny' */}
              {/*                                     disabled={!this.state.filters.competitionId} */}
              {/*                                     content='Generate CSV' */}
              {/*                                     onClick={this.handleDownload}/>} */}
              <Dimmer inverted active={csv.generating}>
                <Loader inverted content='Generating CSV. This can take a few seconds..'/>
              </Dimmer>
            </Form.Group>
          </Form>
        </Segment>
      </div>
    );
  };
};

export default TableHeader;



// WEBPACK FOOTER //
// ./src/private/admin/components/Workshops/Header.js